import Bugsnag from '@bugsnag/js';
import BugsnagPluginVue from '@bugsnag/plugin-vue';
import Vue from 'vue';

export default function () {
    Bugsnag.start({
        apiKey: window.credManager.bugsnagApiKey(),
        plugins: [new BugsnagPluginVue()],

        onError: (event) => {
            const message = event.errors?.[0]?.errorMessage || event.errors?.[0]?.errorClass || ''

            // do not send to Bugsnag
            if (message.includes('xbrowser is not defined') || message.includes('swbrowser is not defined')) {
                return false
            }
        }
    })
    const bugsnagVue = Bugsnag.getPlugin('vue');
    bugsnagVue.installVueErrorHandler(Vue);
}
